export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5311.43e43af5.jpg";